import { ChartPieProps } from 'types/Chart';
import { numberWithCommas } from 'utils/utils';


const getCenetrText = (data: number[], title: string, complaintCount: number) => {
    const sum = complaintCount ?? data.reduce((accumulator, currentValue) => accumulator + currentValue, 0);
    const sumNumber = numberWithCommas(sum)
    return [`${sumNumber}`, `${title}`]
}
export const chartOptions = (props: ChartPieProps, isContrast: boolean) => {

    return {
        rotation: props.rotation ?? 0,
        circumference: props.circumference ?? 360,
        cutout: '75%',
        responsive: true,
        elements: {
            center: {
                color: isContrast ? 'white' : 'black',
                text: getCenetrText(props.details.data, props.details.title, props.complaintCount),
                font: '1.2rem Arial'
            }
        },
        plugins: {
            tooltip: {
                enabled: false // Disable tooltips here
            },
            legend: {
                position: 'left',
                rtl: true,
                textDirection: 'ltr',
                display: false,
                labels: {
                    usePointStyle: true,
                    pointStyle: 'circle',
                    font: { weight: 'bold' },
                    padding: 20,
                    textAlign: 'left'
                }
            },
        }
    }
}

export const centerTextSetting = {
    id: 'customCenterText',
    afterDraw: (chart) => {
        const { ctx, chartArea: { left, right, top, bottom }, config: { options: { elements: { center: centerConfig } } } } = chart;

        const [centerX, centerY] = [(left + right) / 2, (top + bottom) / 2];
        const { font, color, text: lines } = centerConfig;

        ctx.save();
        ctx.font = font;
        ctx.fillStyle = color;
        ctx.textAlign = 'center';

        lines.forEach((line, i) => ctx.fillText(line, centerX, centerY - (lines.length - 1) * 12 + 24 * i));
        ctx.restore();
    }
};